import FlexPane from 'presentation/components/flex-pane/index.jsx';
import Button from 'presentation/components/button/index.jsx';
import Text from 'presentation/components/text/index.jsx';
import RotatableImage from 'presentation/components/rotatable-image/index.jsx';

export default function QuickNavigationButton(props) {
    const {
        mojitoTools: { config },
        title,
        subTitle,
        disabled,
        onClick,
        isExpanded,
    } = props;

    return (
        <Button
            class="ta-quickNavigationButton"
            config={config.container}
            onClick={onClick}
            disabled={disabled}
        >
            {props.children}
            <Text config={config.titleLabel}>{title}</Text>
            <FlexPane config={config.subTitleContainer}>
                <Text config={config.subTitleLabel}>{subTitle}</Text>
                {!disabled && (
                    <RotatableImage
                        config={config.expandButtonIcon}
                        angle={isExpanded ? '0deg' : '180deg'}
                    />
                )}
            </FlexPane>
        </Button>
    );
}
